//
//
// getViewportDimensions
// Returns the viewport's dimensions
//
function getViewportDimensions() {
    return {
        height: window.innerHeight,
        width: window.innerWidth,
    };
}
//
// getScreenSize
// Returns the viewport's size label based on width
//
function getScreenSize() {
    var width = getViewportDimensions().width;
    if (width >= 1024) {
        return "lg";
    }
    else if (width >= 768) {
        return "md";
    }
    else {
        return "sm";
    }
}
/**
 * Keep this in sync with tailwind screens theme.
 */
var screens = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
};
function isScreen(size) {
    var width = getViewportDimensions().width;
    if (size === 'sm') {
        return width > screens.sm;
    }
    else if (size === 'md') {
        return width > screens.md;
    }
    else if (size === 'lg') {
        return width > screens.lg;
    }
    else if (size === 'xl') {
        return width >= screens.xl;
    }
}
export { getScreenSize as g, isScreen as i };
